import {
  providerLiveReplacingNames,
  providerReplacingNames,
} from 'modules/SlotsRoot/providersData/GameCatalog/GameCatalogUtils'
import { Providers, ProvidersType } from 'modules/SlotsRoot/types/configuration'

import { renameProducerForKeltgamesStart } from '../helpers'

export const producersSortArray = ['amatic', 'evolution', 'pragmaticplaylive', 'pragmaticplay', 'Sport']
export const excludeProducersArray = ['bcraft', 'evolution', 'pragmaticexternal', 'pragmatic']

export const intergrationsExcludeArray = ['89fa86ca']

const replaceIntegrationsForSlotsHistory: Record<string, ProvidersType> = {
  outcome: Providers.otc as ProvidersType,
  keltgames: Providers.KELTGAMES,
  softswiss: Providers.softwiss,
}

const providerMappings: Record<string, string> = {
  ...providerReplacingNames,
  ...providerLiveReplacingNames,
  ...renameProducerForKeltgamesStart,
}

const normalizeProvider = (provider?: string) => {
  if (!provider) return ''
  const key = provider.toLowerCase()
  return providerMappings[key] ?? key
}

const normalizeRouteProvider = (routeProvider?: string): ProvidersType | string => {
  if (!routeProvider) return ''
  const key = routeProvider.toLowerCase()
  const replaced = replaceIntegrationsForSlotsHistory[key]
  if (replaced) {
    return replaced
  }
  return routeProvider
}

export const renameProducerForBetshistory: Record<string, string> = {
  evosw: 'evolution',
}

export const getReplaceProvidersForSlotsHistory = (provider: string) => normalizeProvider(provider)

export const getReplaceIntegrationForSlotsHistory = (routeProvider: string): ProvidersType | string =>
  normalizeRouteProvider(routeProvider)

export const changeProviderBeforeSend = (provider: string) => {
  if (!provider || provider === 'all') {
    return undefined
  }
  return normalizeProvider(provider)
}
